export default {
  outList: [
    {
      light_point_4:[
        {
          title: '鲲鹏翼 飞檐腰线',
          type: 'image',
          video: '',
          image: 'lightPoint/1/3.jpg',
          text: '',
        }
      ],
      light_point_3:[
        {
          title: '鲲鹏超能混动C-DM',
          type: 'image',
          video: '',
          image: 'lightPoint/2/1.jpg',
          text: '热效率≥44.5%，功率115kW，扭矩220Nm',
          text2:'同级热效率天花板，榨干每一滴油'
        },
      ],
      light_point_1:[
        {
          title: '笼式结构 磐石车身',
          type: 'image',
          video: '',
          image: 'lightPoint/3/1.jpg',
          text: '车身行业白车身安全新标杆',
        },
      ],
      light_point_2:[
        {
          title: '星河转 超大轮毂',
          type: 'image',
          video: '',
          image: 'lightPoint/1/2.jpg',
          text: ''
        }
      ]
    }
  ],
  innerList: [
    {
      light_point_1:[
        {
          title: '0重力女王副驾',
          type: 'image',
          video: '',
          image: 'lightPoint/4/1.jpg',
          text: 'SONY殿堂级音响14扬',
          text2: '照顾到每一位家人的感受'
        }
      ],
      light_point_2:[
        {
          title: '气味3.0标准 AQS净化系统',
          type: 'image',
          video: '',
          image: 'lightPoint/4/4.jpg',
          text: '空调急速降温、急速取暖、智能除味'
        },
      ],
      light_point_3:[
        {
          title: '360°环抱式10气囊防护',
          type: 'image',
          video: '',
          image: 'lightPoint/3/2.jpg',
          text: '远端气囊有效降低头部碰撞的二次伤害',
        }
      ],

      light_point_4:[
        {
          title: '观风云 舒享座舱',
          type: 'image',
          video: '',
          image: 'lightPoint/1/4.jpg',
          text: ''
        }
      ],
      light_point_5:[
        {
          title: '后排空调',
          type: 'image',
          video: '',
          image: 'lightPoint/4/6.jpg',
          text: '入座即享的极致奢华',
        }
      ]
    }
  ],
  tab1:[
    {
      title: '听风吟 律动格栅',
      type: 'image',
      video: '',
      image: 'lightPoint/1/1.jpg',
      text: ''
    },
    {
      title: '星河转 超大轮毂',
      type: 'image',
      video: '',
      image: 'lightPoint/1/2.jpg',
      text: ''
    },
    {
      title: '鲲鹏翼 飞檐腰线',
      type: 'image',
      video: '',
      image: 'lightPoint/1/3.jpg',
      text: '',
    },
    {
      title: '观风云 舒享座舱',
      type: 'image',
      video: '',
      image: 'lightPoint/1/4.jpg',
      text: ''
    }
  ],
  tab2: [
    {
      title: '鲲鹏超能混动C-DM',
      type: 'image',
      video: '',
      image: 'lightPoint/2/1.jpg',
      text: '热效率≥44.5%，功率115kW，扭矩220Nm',
      text2:'同级热效率天花板，榨干每一滴油'
    },
    {
      title: '高性能混动专用电池',
      type: 'image',
      video: '',
      image: 'lightPoint/2/2.jpg',
      text: '能量高，密度大'
    },
    {
      title: '3DHT超混变速箱',
      type: 'image',
      video: '',
      image: 'lightPoint/2/3.jpg',
      text: '双电机前驱，三电机四驱，国家科技部认证的3DHT混动变速箱'
    },
    {
      title: '210km纯电续航，200km/h连续高速行驶',
      type: 'image',
      video: '',
      image: 'lightPoint/2/4.jpg',
      text: '反向虚标，让每一度电都走的更远，高速不失速，行驶全程放心'
    }
  ],
  tab3: [
    {
      title: '笼式结构 磐石车身',
      type: 'image',
      video: '',
      image: 'lightPoint/3/1.jpg',
      text: '车身行业白车身安全新标杆',
    },
    {
      title: '360°环抱式10气囊防护',
      type: 'image',
      video: '',
      image: 'lightPoint/3/2.jpg',
      text: '远端气囊有效降低头部碰撞的二次伤害',
    }
  ],
  tab4: [
    {
      title: '0重力女王副驾',
      type: 'image',
      video: '',
      image: 'lightPoint/4/1.jpg',
      text: 'SONY殿堂级音响14扬',
      text2: '照顾到每一位家人的感受'
    },
    {
      title: '二排舒享座椅',
      type: 'image',
      video: '',
      image: 'lightPoint/4/2.jpg',
      text: '母婴级材质',
      text2: '照顾到每一位家人的感受'
    },
    {
      title: 'CDC“磁悬浮”悬架',
      type: 'image',
      video: '',
      image: 'lightPoint/4/3.jpg',
      text: '稳住所有起伏，给家人稳稳的幸福'
    },
    {
      title: '气味3.0标准 AQS净化系统',
      type: 'image',
      video: '',
      image: 'lightPoint/4/4.jpg',
      text: '空调急速降温、急速取暖、智能除味'
    },
    {
      title: '头枕音响',
      type: 'image',
      video: '',
      image: 'lightPoint/4/5.jpg',
      text: '入座即享的极致奢华'
    },
    {
      title: '后排空调',
      type: 'image',
      video: '',
      image: 'lightPoint/4/6.jpg',
      text: '入座即享的极致奢华',
    }
  ],
}
